import { Alert } from 'react-bootstrap-5';
import PropTypes from 'prop-types';
import React from 'react';

export default function ContactAlert({ contactErrors }) {
  if (contactErrors.length === 0) return null;

  return (
    <Alert className="d-flex align-items-center" variant="danger">
      <div className="ms-4 mt-1">
        <div><strong>The following errors occurred when trying to save this form. Please fix and re-submit.</strong></div>
        <ul className="mb-0">
          {contactErrors.map(error => <li key={error}>{error}</li>)}
        </ul>
      </div>
    </Alert>
  );
}

ContactAlert.propTypes = {
  contactErrors: PropTypes.arrayOf(PropTypes.string).isRequired
};
